// filterSlice.js
import { createSlice } from '@reduxjs/toolkit';

const localStorageKey = 'cacheFilter';
const initialState = JSON.parse(localStorage.getItem(localStorageKey)) || { history: [] };

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      const { pageKey, filterValue } = action.payload;
      state[pageKey] = filterValue;
      
    },
    sethistoryState :(state, action) => {
      const {  filterValue } = action.payload;
      if (!state.history) {
        state.history = [];
      }
      state.history.push(filterValue.path)
      if(state.history.length>2){
        state.history.shift()
      }

    },

    clearFilter: (state) => {
      return{history: state.history}
    },
   
  }
});

export const { setFilter, clearFilter,sethistoryState } = filterSlice.actions;
export default filterSlice.reducer;
